import { Image as ImageAntd } from 'antd'
import { clsx } from 'clsx'
import { Preview } from 'component/Image/Preview'
import { PreviewControl, usePreviewControl } from 'component/Image/PreviewControl'
import { fixImageUrl } from 'component/Image/util'
import { useLatestCallback } from 'hook/useLatestCallback'
import { useState } from 'react'
import { mutable } from 'util/type'
import css from './Image.module.scss'

type Props = {
  className?: string
  contain?: boolean
  round?: boolean
  sources?: readonly string[]
  src: string
  control?: PreviewControl
}

export const Image = (props: Props) => {
  const [good, setGood] = useState(false)
  const { contain, round, sources } = props
  const src = fixImageUrl(props.src)
  const pointer = !!sources || !!props.control
  const className = clsx(props.className, css.image, !good && css.bad,
    contain && css.contain, pointer && css.pointer, round && css.round)
  const control = usePreviewControl()
  const inner = sources && !props.control

  const onLoad = useLatestCallback(() => {
    setGood(true)
  })

  const onError = useLatestCallback(() => {
    setGood(false)
  })

  const onClick = useLatestCallback(() => {
    if (props.control) props.control.setPreview(src)
    else if (sources) control.setPreview(src)
  })

  return <>
    <ImageAntd wrapperClassName={className} src={src} preview={false}
      onClick={onClick} onLoad={onLoad} onError={onError} />
    {inner && <Preview control={control} sources={mutable(sources)} />}
  </>
}
